// A colour this helper can decode: 3-digit shorthand or 6-digit hex.
const HEX_COLOR = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

// Helper to darken (negative percent) or lighten (positive percent) a hex color
// for hover states (fixed DEFECT-30). A 3-digit shorthand is expanded
// digit-by-digit ('#abc' → '#aabbcc') before decoding; anything else (a CSS color
// name, an empty string, a malformed hex) is returned unchanged instead of being
// decoded into a wrong colour. Channels are clamped to 0..255, and a non-finite
// percent leaves the colour unadjusted.
export const adjustColor = (hex: string, percent: number): string => {
  if (typeof hex !== 'string' || !HEX_COLOR.test(hex)) {
    return hex;
  }

  const digits = hex.slice(1);
  const expanded =
    digits.length === 3
      ? digits
          .split('')
          .map((digit) => digit + digit)
          .join('')
      : digits;
  const num = parseInt(expanded, 16);
  const shift = Number.isFinite(percent) ? percent : 0;
  const r = Math.max(0, Math.min(255, (num >> 16) + shift));
  const g = Math.max(0, Math.min(255, ((num >> 8) & 0x00ff) + shift));
  const b = Math.max(0, Math.min(255, (num & 0x0000ff) + shift));
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
};

// Helper to create a light tint of a color (for selected backgrounds)
export const createLightTint = (hex: string, opacity: number = 0.1): string => {
  return `${hex}${Math.round(opacity * 255).toString(16).padStart(2, '0')}`;
};

// Locale resolution: the single rule lives in formatting.ts (same rule as
// getCurrentLocale) and is re-exported here for the settlement page, which
// imports it from this module (DEFECT-30).
export { resolveLocale } from './formatting';
